import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as offer from "./style.module.scss";
export const Offer = () => {
  return (
    <section className={offer.offer} id="results">
      <div className="container">
        <h2 className={main.titleH2}>Что даёт кураторское сопровождение?</h2>
        <div className={offer.offer__blocks}>
          <div className={offer.offer__block}>организует учебный процесс;</div>
          <div className={offer.offer__block}>формирует привычку учиться регулярно;</div>
          <div className={offer.offer__block}>направляет и&nbsp;настраивает ответственность ребёнка;</div>
          <div className={offer.offer__block}>обеспечивает мягкий контроль за&nbsp;прогрессом и&nbsp;результатами.</div>
        </div>
      </div>
    </section>
  );
};
